import React from 'react'

const Profile = React.memo(() => {
  return (
    <div>
      <h1>ICH BRINGE EIN</h1>
      <p>
        Seit 2014 Arbeite ich als Fachkraft für Arbeitssicherheit für einen
        Maximalversorger in der Gesundheitsbranche. In meiner freiberuflichen
        Nebentätigkeit berate ich kleine und mittlere Unternehmen in Berlin und
        Brandenburg. Als Brandschutzbeauftragter nutze ich zusätzliches
        Expertenwissen für Gefährdungsbeurteilungen und Schulungen. <br /> Mit
        meiner Familie wohne ich in Panketal und neben meiner Arbeit
        interessiere ich mich für Wassersport, Caravaning und technische
        Spielerein.
      </p>
    </div>
  )
})

export default Profile
